import * as M from 'materialize-css';
import Vue from 'vue';
import '../scss/styles.scss';
import { CarouselCardItem } from '../models/CarouselCardItem';

export default Vue.extend({
  name: 'carouselcard',
  props: {
    items: {
      type: Array as () => CarouselCardItem[],
      required: true,
    },
    indicators: {
      type: Boolean,
      required: false,
      default: false,
    },
    dist: {
      type: Number,
      required: false,
      default: -100,
    },
    padding: {
      type: Number,
      required: false,
      default: 0,
    },
    numVisible: {
      type: Number,
      required: false,
      default: 5,
    },
    noWrap: {
      type: Boolean,
      required: false,
      default: false,
    },
    shift: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    clicked(item: CarouselCardItem) {
      this.$emit('carouselItemClicked', item);
    },
  },
  data() {
    return {
      carousel: HTMLElement,
      mCarousel: null as any | null,
    };
  },
  mounted() {
    const elem: Element = document.querySelector('.carousel') || this.$refs['carousel'] as Element;
    M.Carousel.init(elem, {});
    this.mCarousel = M.Carousel.getInstance(elem);
    const t = new M.Carousel(elem, {
      indicators: this.indicators,
      dist: this.dist,
      padding: this.padding,
      numVisible: this.numVisible,
      noWrap: this.noWrap,
      shift: this.shift,
    });
  },
  beforeDestroy() {
    this.mCarousel.destroy();
  },
});
